import { useSocket } from 'contexts/socketcontext/hooks';
import { attachSocketAuthLifecycle, initializeSocketConnection } from 'contexts/socketcontext/utils';
import { useUserInformationContext } from 'contexts/userContext';
import { usePreferences } from 'contexts/preferences-context';
import { useUserAuth } from 'hooks/useUserAuth';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

export default function AuthenticatedLayout() {
  const history = useHistory();
  const location = useLocation();
  const { isAuthenticated } = useUserAuth();
  const { t, i18n } = useTranslation();
  const { socket, updateSocket } = useSocket();

  const { currentUser, userIsTitleAdmin } = useUserInformationContext();
  const { selectedAgencyId, setSelectedAgencyId, setLanguage } = usePreferences() as any;

  const userLetters = currentUser
    ? `${currentUser.first_name.charAt(0)}${currentUser?.last_name?.charAt(0) ?? ''}`
    : '';

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [templateAnchorEl, setTemplateAnchorEl] = useState<null | HTMLElement>(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState<null | HTMLElement>(null);

  const selectAgency = (agencyId: string) => {
    if (currentUser && currentUser.accesses) {
      const isValid = agencyId === '' || currentUser.accesses.some((agency) => agency._id === agencyId);
      if (isValid) {
        setSelectedAgencyId(agencyId);
      }
    }
  };

  useEffect(() => {
    if (!socket) {
      if (isAuthenticated) updateSocket(initializeSocketConnection());
      return undefined;
    }

    const detachLifecycle = attachSocketAuthLifecycle(socket);

    return () => {
      detachLifecycle();
      socket.off();
      socket.disconnect();
      updateSocket(null);
    };
  }, [isAuthenticated, socket, updateSocket]);

  return {
    t,
    i18n,
    history,
    location,
    userIsTitleAdmin,
    anchorEl,
    setAnchorEl,
    mobileMoreAnchorEl,
    setMobileMoreAnchorEl,
    userLetters,
    agencySelected: selectedAgencyId,
    selectAgency,
    templateAnchorEl,
    setTemplateAnchorEl,
    setLanguage,
  };
}
